import classNames from "components/ui/classNames";

interface FiltersButtonArrayProps {
  filters: {
    key: string;
    label: string;
    disabled?: boolean;
    hidden?: boolean;
  }[];
  filter: string;
  setFilter: (filter: string) => void;
}

export default function FiltersButtonArray({ filters, filter, setFilter }: FiltersButtonArrayProps) {
  return (
    <div
      className={classNames(
        "relative min-h-6",
        "flex gap-2 gap-y-2.5 rounded-xl sm:flex-wrap",
        "dark:border-slate-950",
        "scrollbar-none",
        "overflow-x-scroll",
      )}
    >
      {filters
        .filter((node) => !node.hidden)
        .map((node) => {
          const isSelected = node.key === filter;

          return (
            <button
              key={node.key}
              type="button"
              disabled={node.disabled}
              className={classNames(
                "flex flex-nowrap",
                "whitespace-nowrap rounded-full p-1.5 px-3 text-sm font-medium sm:px-2.5 sm:py-0.5",
                "leading-5 tracking-normal",
                "bg-slate-200/80 text-slate-600",
                {
                  "dark:bg-sky-900/70 dark:text-sky-400 dark:hover:bg-sky-800 dark:hover:text-sky-300": !isSelected,
                  "dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-teal-800 dark:hover:text-teal-300": isSelected,
                },
                "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-300 focus-visible:ring-offset-2",
                "focus-visible:border-transparent",
                "focus-visible:dark:ring-slate-600 focus-visible:dark:ring-offset-transparent",
                "disabled:cursor-not-allowed",
                {
                  "bg-blue-600 font-bold text-white": isSelected,
                  "hover:bg-slate-600 hover:text-white": !isSelected,
                },
              )}
              onClick={() => {
                setFilter(node.key);
              }}
            >
              <span className="truncate">{node.label}</span>
            </button>
          );
        })}
    </div>
  );
}
